import { css, unsafeCSS } from 'lit-element';
export const dynamicStyles = (color) => {
    const colorValue = unsafeCSS(color);
    return css `
    .button-base.selected {
      background: var(--${colorValue}-color-medium);
      color: var(--${colorValue}-contrast-color);
    }
    .button-base.selected:not(.no-hover):hover {
      background: var(--${colorValue}-color-dark);
    }
  `;
};
export default css `
  :host {
    --pagination-button-height: 32px;
    --pagination-button-width: 30px;
  }

  .pagination-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, var(--pagination-button-width));
    align-items: center;
    justify-content: center;
    gap: 7px;
  }

  .button-base {
    background: var(--white);
    border-radius: var(--default-border-radius);
    border: 1px solid var(--black-20);
    color: var(--black-80);
    cursor: pointer;
    font-family: var(--font-family);
    font-size: var(--sm-font-size);
    font-weight: var(--semibold-font-weight);
    height: var(--pagination-button-height);
    outline: 0;
    transition: background 0.3s ease;
    width: var(--pagination-button-width);
  }

  .button-base:disabled {
    background: var(--black-20);
    color: var(--black-60);
    cursor: not-allowed;
  }

  .button-base:disabled > .button-base:hover {
    background-color: unset !important;
    color: unset !important;
  }

  .button-base:not(.no-hover):hover {
    background: var(--bg-color);
  }

  .button-base.selected {
    border: none;
  }

  .ellipsis {
    align-items: center;
    cursor: default;
    display: flex;
    justify-content: center;
    cursor: not-allowed;
  }

  .ellipsis-disabled {
    background: var(--black-20);
    color: var(--black-60);
  }

  .arrow {
    border: solid var(--black-80);
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
  }

  .arrow-disabled {
    border-color: var(--black-60);
  }

  .right {
    margin-left: -4px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .left {
    margin-right: -3px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }
`;
